export const ADMIN_ROOT = '/admin' as const;
export const ADMIN_ACCESS_DENIED = '/admin/access-denied' as const;
export const ADMIN_DASHBOARD = '/admin/dashboard' as const;
export const ADMIN_USERS = '/admin/users' as const;
export const ADMIN_WORKSPACES = '/admin/workspaces' as const;
